import AdimUsers from "Pages/AdminUser/User"
import Customers from 'Pages/Customers/User'
import Permissions from 'Pages/Permissions/Permissions'
import ApproveRequest from 'Pages/ApproveRequest/request'
import Logs from 'Pages/Logs/Logs'
import Notifications from "Pages/Notifications/Notifications"
import Config from 'Pages/config/settings'
import Noti from 'Pages/Noti/page'
import FAQ from 'Pages/FAQ/page'
import GoogleAnalytics from 'Pages/Analytics/Page'
import Settings from "Pages/Settings/Permissions"
import AddFaq from "Pages/FAQ/AddFaq"
export const AccessKeys = {
 adminUsers: 'AdminUsers',
 Customers: 'Customers',
 Permissions: 'Permissions',
 ApproveRequest: 'ApproveRequest',
 Logs: 'Logs',
 Notifications: "Notifications",
 Config: "Config",
 "FAQ": "FAQ",
 GoogleAnalytics: "GoogleAnalytics",
 Settings: "Settings"
}

export const PageRoutes = [
 { path: '/AdminUsers', element: <AdimUsers />, AccessKey: AccessKeys.adminUsers, Type: 'read' },
 { path: '/google-analytics', element: <GoogleAnalytics />, AccessKey: AccessKeys.GoogleAnalytics, Type: 'read' },
 { path: '/customers', element: <Customers />, AccessKey: AccessKeys.Customers, Type: 'read' },
 { path: '/permissions', element: <Permissions />, AccessKey: AccessKeys.Permissions, Type: 'read' },
 { path: '/approve-request', element: <ApproveRequest />, AccessKey: AccessKeys.ApproveRequest, Type: 'read' },
 { path: '/logs', element: <Logs />, AccessKey: AccessKeys.Logs, Type: 'read' },
 { path: '/notifications', element: <Notifications />, AccessKey: AccessKeys.Notifications, Type: 'read' },
 { path: '/faq', element: <FAQ />, AccessKey: AccessKeys.FAQ, Type: 'read' },
 { path: '/faq/:type', element: <AddFaq />, AccessKey: AccessKeys.FAQ, Type: 'write' },
 { path: '/all-notifications', element: <Noti />, AccessKey: AccessKeys.Notifications, Type: 'read' },
 { path: '/config', element: <Config />, AccessKey: AccessKeys.Config, Type: 'read' },
 { path: '/settings', element: <Settings />, AccessKey: AccessKeys.Settings, Type: 'read' },

]